// extracted by mini-css-extract-plugin
module.exports = {"menu_item_container":"menu_item_container___Ur9HT","icon":"icon___2GSVq"};